import Conversation from './conversation-container';

export default Conversation;
